/**
 * Lista curada de iconos de Material Icons.
 *
 * Es una lista fija y no el set completo (más de 2000) a propósito: elegir entre
 * dos mil iconos no es elegir, es buscar. Están los que tienen sentido en un
 * sistema de administración de alquileres, agrupados por para qué sirven.
 *
 * Todos son ligatures de la fuente "Material Icons" que ya carga la app, así que
 * no hay que sumar ninguna dependencia.
 */
export interface GrupoIconos {
  grupo: string
  iconos: string[]
}

export const ICONOS_DISPONIBLES: GrupoIconos[] = [
  {
    grupo: 'Dinero y cobranza',
    iconos: [
      'payments', 'paid', 'attach_money', 'money_off', 'savings',
      'account_balance', 'account_balance_wallet', 'credit_card', 'receipt_long',
      'request_quote', 'point_of_sale', 'currency_exchange', 'percent'
    ]
  },
  {
    grupo: 'Saldos y tendencias',
    iconos: [
      'trending_up', 'trending_down', 'trending_flat', 'call_split', 'call_merge',
      'north_east', 'south_east', 'balance', 'equalizer', 'insights'
    ]
  },
  {
    grupo: 'Contratos y legales',
    iconos: [
      'gavel', 'approval', 'assignment', 'assignment_turned_in', 'assignment_late',
      'description', 'article', 'fact_check', 'history_edu', 'draw', 'policy'
    ]
  },
  {
    grupo: 'Propiedades',
    iconos: [
      'home', 'home_work', 'apartment', 'villa', 'cottage', 'store', 'warehouse',
      'meeting_room', 'vpn_key', 'location_city', 'garage'
    ]
  },
  {
    grupo: 'Personas',
    iconos: [
      'person', 'people', 'groups', 'badge', 'support_agent', 'work',
      'engineering', 'handshake', 'family_restroom'
    ]
  },
  {
    grupo: 'Fechas y estados',
    iconos: [
      'event', 'event_available', 'event_busy', 'schedule', 'update', 'alarm',
      'check_circle', 'cancel', 'block', 'warning', 'error', 'pending',
      'hourglass_bottom', 'task_alt'
    ]
  },
  {
    grupo: 'Movimientos y caja',
    iconos: [
      'input', 'output', 'swap_horiz', 'swap_vert', 'sync_alt', 'move_up',
      'move_down', 'inventory', 'local_offer', 'sell', 'redeem', 'discount'
    ]
  },
  {
    grupo: 'Servicios',
    iconos: [
      'bolt', 'water_drop', 'local_fire_department', 'wifi', 'phone',
      'cleaning_services', 'plumbing', 'handyman', 'build', 'security',
      'local_shipping', 'delete'
    ]
  },
  {
    grupo: 'Genéricos',
    iconos: [
      'label', 'bookmark', 'star', 'flag', 'circle', 'category', 'folder',
      'more_horiz', 'info', 'help', 'note', 'push_pin'
    ]
  }
]

/** Cuando un tipo no tiene icono cargado */
export const ICONO_POR_DEFECTO = 'swap_horiz'
